export class SeasonUtilities {
    static formatSeasonName(seasonName: string, formatType: 'short' | 'long' | 'YY' = 'short'): string {
        if (!/^Season [0-9]+$/.test(seasonName)) {
            throw new Error(`Invalid season name format: ${seasonName}`);
        }

        const [_, number] = seasonName.split(' ');
        const numberYY = number.substring(2);

        if (formatType === 'short') {
            return `S ${numberYY}`;
        }

        if (formatType === 'YY') {
            return `${numberYY}`;
        }

        return seasonName;
    }
}
